// -------------------------------------------------------------------------------
// Libraries
// -------------------------------------------------------------------------------

// -------------------------------------------------------------------------------
// Components
// -------------------------------------------------------------------------------
import MusicPlayer from '../music-player/MusicPlayer';

// -------------------------------------------------------------------------------
// Styles and Utils
// -------------------------------------------------------------------------------
import { StyledMusicPlayerRow } from './style';

// -------------------------------------------------------------------------------
// Component
// -------------------------------------------------------------------------------
export function MusicPlayerRow({ track, firstLoad, openModal}) {
  return (
    <StyledMusicPlayerRow>
      {track && <MusicPlayer track={track} firstLoad={firstLoad} openModal={openModal} />}
    </StyledMusicPlayerRow>
  );
}

export default MusicPlayerRow;
